import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { PortalEnvSchema } from '@playerbase/types';

const env = PortalEnvSchema.parse({
  VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
  VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
  VITE_SITE_URL: import.meta.env.VITE_SITE_URL,
});

// Pin flowType: 'pkce' so AuthCallbackPage's exchangeCodeForSession is
// deterministic regardless of upstream Supabase JS default drift.
//
// detectSessionInUrl: false hands ownership of the URL code exchange to
// AuthCallbackPage. With the default (true), supabase-js auto-exchanges the
// code on client init *and* AuthCallbackPage exchanges it again, racing each
// other - the library wins, fires PASSWORD_RECOVERY before our listener is
// registered, and our subsequent call hits a verifier-already-consumed path
// that breaks the post-exchange navigation to /reset-password.
export const supabase: SupabaseClient = createClient(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY, {
  auth: {
    flowType: 'pkce',
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});
